// 目前 API 还比较少，暂时都放在这一个文件中，将来需要进一步拆分
import { ApiResultWithPagination, ApiResult, request } from '@ns/ts/request'
import { ArticleListData, QueryWordData } from 'sdss/types/ListArticlesModules'

if (process.env.NODE_ENV !== 'production') {
  // @ts-ignore
  window.request = request
}

// 文章列表
export type ListArticlesApiResult = ApiResultWithPagination<ArticleListData>
async function listArticles(
  params: {
    page: number, // 页码
    page_size: number, // 每页展示数量
    article_type_list?: string, // 文章类型(可多选)
    min_publication_datetime_stamp?: number, // 最早发布时间(前端计算后的时间戳)
    query_word?: string, // 搜索词
  }
): Promise<ListArticlesApiResult> {
  const resp = await request({
    url: '/api/articles',
    params,
  })
  return resp.data
}

export type QueryWordApiResult = ApiResult<QueryWordData[]>
async function queryWord(
): Promise<QueryWordApiResult> {
  const resp = await request({
    url: '/api/query-word/recommend',
  })
  return resp.data
}

async function search(
  params: {
    page: number,
    page_size: number,
    query_word: string,
  },
): Promise<any> {
  const resp = await request({
    params,
    url: '/api/articles'
  })
  return resp.data
}

export default {
  listArticles,
  queryWord,
  search,
}
